import {
  HHCheckbox,
  HHFormControlLabel,
} from '@hinge-health/react-component-library';
import { Controller, useFormContext } from 'react-hook-form';
import { billableActivitiesMap } from '../../../../../constants/strings/contract/form-constants';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../../../../utils/bills-utils';
import { PackageFormData } from '../../custom-package-types';
import { EngagementTypeWithRules, RuleType } from '../engagement-types-rules';
import { BillableActivitiesProps } from './billable-activities';

export interface BillableActivityCheckBoxProps
  extends Pick<BillableActivitiesProps, 'wholeFormDisabled'> {
  engagementType: EngagementTypeWithRules;
  index: number;
}

const BillableActivityCheckBox = ({
  engagementType,
  wholeFormDisabled,
  index,
}: BillableActivityCheckBoxProps): JSX.Element => {
  const { control } = useFormContext<PackageFormData>();
  const engagementTypeDefaultSubType = engagementType.subTypeOptions?.[
    RuleType[engagementType.name as keyof typeof RuleType]
  ]?.find(subType => subType.defaultSelected);

  const label =
    billableActivitiesMap[engagementType.name] ??
    capitalizeFirstLetterAndSpaceSnakeString(engagementType.name);

  return (
    <HHFormControlLabel
      key={engagementType.id}
      data-testid={`billable-activity-${label.toLowerCase().replace(/ /g, '-')}-checkbox`}
      label={label}
      control={
        <Controller
          control={control}
          name={`selectedPackages.${index}.selectedBillableActivities`}
          render={({ field: { onChange, value } }): JSX.Element => (
            <HHCheckbox
              hhVariant="primary"
              disabled={wholeFormDisabled}
              sx={{ color: 'gray' }}
              checked={engagementType.id in value}
              onChange={(): void => {
                const newValue = { ...value };
                if (engagementType.id in newValue) {
                  delete newValue[engagementType.id];
                } else {
                  newValue[engagementType.id] = engagementTypeDefaultSubType
                    ? {
                        [RuleType[
                          engagementType.name as keyof typeof RuleType
                        ]]: engagementTypeDefaultSubType.value,
                      }
                    : null;
                }
                onChange(newValue);
              }}
            />
          )}
        />
      }
    />
  );
};

export default BillableActivityCheckBox;
